module.exports = __webpack_public_path__ + "static/media/Vestas_Picture3.b4232c64.png";